import React from 'react';

interface ReportSalesActivityProps {
  value: number;
  benchmarkValue: number;
  minValue: number;
  maxValue: number;
}

const ReportSalesActivity: React.FC<ReportSalesActivityProps> = ({
  value,
  benchmarkValue,
  minValue,
  maxValue,
}: ReportSalesActivityProps) => {
  // Convert to numbers and provide fallbacks
  const numericValue = Number(value) || 0;
  const numericBenchmark = Number(benchmarkValue) || 0;
  const numericMax = Number(maxValue) || 100;

  const barLength = numericMax;
  const driverAvg = numericBenchmark;
  const avgPercentage = (driverAvg / barLength) * 100;
  const percentage = (numericValue / barLength) * 100;
  const isExceedingMax = numericValue > barLength;

  // Color coding logic from RepBattleCard
  let barBackgroundColor = '';
  let valueColor = '';
  const deviation = avgPercentage * 0.1;
  let redColorVal = avgPercentage - deviation;
  let orangeColorVal = avgPercentage + deviation;

  if (percentage < redColorVal) {
    barBackgroundColor = '#ef4444';
    valueColor = '#dc2626'; // Red
  } else if (percentage >= redColorVal && percentage < orangeColorVal) {
    barBackgroundColor = '#f59e0b';
    valueColor = '#ca8a04'; // Orange
  } else {
    barBackgroundColor = '#10b981';
    valueColor = '#16a34a'; // Green
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      <span
        style={{
          fontSize: '14px',
          fontWeight: 500,
          color: valueColor,
          fontFamily: 'Rubik',
        }}
      >
        {numericValue % 1 === 0 ? numericValue : numericValue.toFixed(1)}
      </span>
      <div
        style={{
          position: 'relative',
          width: '110px',
          height: '7px',
          backgroundColor: '#e5e7eb',
          borderRadius: '4px',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            height: '100%',
            width: `${isExceedingMax ? 100 : percentage}%`,
            backgroundColor: barBackgroundColor,
            transition: 'width 0.3s ease',
          }}
        />
      </div>
    </div>
  );
};

export default ReportSalesActivity;
